export enum NudgeType {
  BOTTOM_BANNER = 'BOTTOM_BANNER',
  CENTER_BANNER = 'CENTER_BANNER',
  MOBILE_BOTTOM = 'MOBILE_BOTTOM',
  TOP_BANNER = 'TOP_BANNER',
}